import type { BrowseArea } from "../../_hooks/use-room-type-search";
import { CheckItem } from "../../ui/check-item";

/**
 * エリア絞り込みフィルター。
 *
 * Figma（PC: 5141-8041 / SP: 5171-14504 Container コンポーネント）準拠:
 * - コンテナ: grid-cols-[repeat(auto-fill,minmax(110px,1fr))]。320pxで2列 / 400pxで3列に自動、各列は均等幅(1fr)
 * - 各アイテム: チェックボックス（h-[48px] タップターゲット）+ エリア名テキスト
 * - テキスト: 14px, leading-[24px], font-notojp
 */
export function AreaFilter({
  areas,
  selectedAreaSlugs,
  onToggleArea,
}: {
  areas: BrowseArea[];
  selectedAreaSlugs: ReadonlySet<string>;
  onToggleArea: (slug: string) => void;
}) {
  return (
    <div className="grid grid-cols-[repeat(auto-fill,minmax(110px,1fr))] gap-[8px]">
      {areas.map((area) => {
        const checked = selectedAreaSlugs.has(area.slug);
        return (
          <CheckItem
            key={area.id}
            checked={checked}
            onChange={() => onToggleArea(area.slug)}
            className="w-full"
          >
            <span className="font-notojp text-dx-text-default text-[14px] leading-[24px]">
              {area.name}
            </span>
          </CheckItem>
        );
      })}
    </div>
  );
}
